<template>

  <ConfirmDialogue ref="confirmDialogue" />
  <MessageDialogue ref="messageDialogue" />

  <div class="form-group">
    <RadioPicker 
      label="Объект"
      title="Выберите объект"
      placeholder="Поиск объекта"
      v-model="form.object"
      @update:model-value="(val) => {
        form.location = null; 
        form.place = null; 
        form.problem = null; 
        form.floor = null; 
        marker = null;
        if(val !== null) {
          loadLactions(); 
          loadFloors();
        }
      }"
      :list="objects"
    />
  </div>

  <transition name="slide-fade">
    <div class="form-group" v-if="form.object !== null">
      <RadioPicker 
        label="Локация"
        title="Выберите локацию"
        placeholder="Поиск локации"
        v-model="form.location"
        @update:model-value="(val) => { 
          form.place = null; 
          form.problem = null; 
          form.floor = null; 
          marker = null;
          if(val !== null) {
            loadPlaces(); 
          }
        }"
        :list="locations"
      />
    </div>
  </transition>

  <transition name="slide-fade">
    <div class="form-group" v-if="form.location !== null">
      <RadioPicker 
        label="Место"
        title="Выберите место"
        placeholder="Поиск места"
        v-model="form.place"
        @update:model-value="(val) => {
          form.problem = null;
          form.floor = null;
          marker = null;
          if(val !== null) {
            loadProblem(); 
          }
        }"
        :list="places"
      />
    </div>
  </transition>

  <transition name="slide-fade">
    <div class="form-group" v-if="form.place !== null">
      <RadioPicker 
        label="Проблема"
        title="Выберите проблему"
        placeholder="Поиск проблемы"
        v-model="form.problem"
        @update:model-value="() => {
          form.floor = null;
          marker = null;
        }"
        :list="problems"
      />
    </div>
  </transition>

  <template v-if="form.problem !== null && currentPlace.isFloor">
    <!-- Селектор выбора этажа -->
    <transition name="slide-fade">
      <div class="form-group">
        <RadioPicker 
          label="Этаж"
          title="Выберите этаж"
          placeholder="Поиск"
          v-model="form.floor"
          :list="floorsList"
          @update:model-value="(val) => { 
            if(val !== null) {
              marker = null;
              intPanzoom();
            }
          }"
        />
      </div>
    </transition>
    <!-- Селектор выбора точки на плане этажа -->
    <transition name="slide-fade">
      <div class="form-group" v-if="form.floor !== null">
        <div class="scheme">
          <div class="scheme__container" ref="imageContainer" @click="setPoint($event)">
            <img class="scheme__image" ref="image" :src="linkCurrentFloor" alt="Floor Plan">
            <div class="scheme__marker" v-if="marker !== null" :style="{left: marker.x + 'px', top: marker.y + 'px'}"></div>
          </div>
        </div>
        <div class="hint">
          Для продолжения необходимо отметить на плане точку указывающую на место возникновения проблемы.
        </div>
      </div>
    </transition>
  </template>


  <template v-if="(form.problem !== null && marker !== null) || (form.problem !== null && !currentPlace.isFloor)">
    <!-- Комментарий -->
    <div class="form-group" >
      <div class="form-control">
        <textarea v-model="form.comment" rows="5"></textarea>
        <label> Комментарий </label>
      </div>
    </div>
    <!-- Фото -->
    <div class="form-group">
      <GalleryPicker v-model="form.images" uniq="signalPhotoPicker" :viewMode="false" label="Фотоотчёт"/>
    </div>
    <!-- Отправить -->
    <a class="btn btn--default btn--lg btn--inline" @click="saveSignal($event)"> 
      <img class="btn--ico btn--ico--left" src="@/assets/img/2.svg">
      <div class="btn--text"> Сохранить </div>
      <div class="btn--loader"></div>
    </a>
  </template>

</template>



<script setup>
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';
  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
  import RadioPicker from '@/components/ux/RadioPicker.vue';
  import GalleryPicker from '@/components/ux/GalleryPicker.vue';
  import Panzoom from '@panzoom/panzoom';

</script>

<script>
  export default {
    
    name: 'PageSignalsHouse',

    data: () => ({

      panzoom: null,
      marker: null,


      locations: [],
      places: [],
      problems: [],
      floors: [],

      form: {
        object: null,
        location: null,
        place: null,
        problem: null,
        comment: null,
        floor: null,
        images: [],
      },

    }),
    
    computed: {
      user () {
        return this.$store.state.auth.user;
      },
      objects () {
        let o = [];
        for(let house of this.user.houses) {
          o.push({id: house.id, name: house.address});
        }
        return o;
      },
      floorsList () {
        const list = [];
        this.floors.forEach((item) => {
          list.push({id: item.id, name: item.floor});
        });
        return list;
      },
      linkCurrentFloor () {
        const idx = this.floors.findIndex((item) => item.id == this.form.floor);
        return idx !== -1 ? this.floors[idx].link : null;
      },
      currentPlace () {
        const idx = this.places.findIndex((item) => item.id == this.form.place);
        return idx !== -1 ? this.places[idx] : null;
      },

    },


    methods: {

      intPanzoom () {
        // Сбрасываем точки
        this.marker = null;
        // Инициализация
        setTimeout(() => {
          // Инициализация Panzoom
          this.panzoom = Panzoom(this.$refs.imageContainer, {
              minScale: 0.25, // Минимальное значение масштаба
              maxScale: 2, // Максимальное значение масштаба
          });
          // Устанавливаем дэфолтный zoom
          this.panzoom.zoom(1, { animate: true });
        }, 100);
      },

      setPoint (e) {
        const rect = this.$refs.image.getBoundingClientRect();
        const scale = this.panzoom.getScale();
        this.marker = {x: (e.clientX - rect.left) / scale, y: (e.clientY - rect.top) / scale};
        // to do скролить бы к этой точке
      },

      // Подгрузить этажи
      async loadFloors () {
        this.floors = [];
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/houses/' + this.form.object + '/floorImages');
        this.floors = data;
      },

      // Подгрузить локации
      async loadLactions () {
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/signal/location');
        this.locations = data.data;
      },

      // Подгрузить места в зависимости от локации
      async loadPlaces () {
        const param = new URLSearchParams({});
        param.set("signal_item_id", this.form.location);
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/signal/location?' + param);
        this.places = data.data;
      },

      // Подгрузить проблемы в зависимости от места
      async loadProblem () {
        const param = new URLSearchParams({});
        param.set("signal_item_id", this.form.place);
        const {data} = await this.axios.get(this.$store.state.api_endpoint + '/signal/problems?' + param);
        this.problems = data.data;
      },

      async saveSignal (e) {

        // Кнопка с барашком
        const btn = e.currentTarget;
        
        // Включаем барашка
        btn.classList.add('btn--load');

        // Параметры запроса
        const params = {
          employeeId: this.user.id,
          houseId: this.form.object,
          signalProblemId: this.form.problem,
          employeeComment: this.form.comment,
          images: this.form.images,
        }

        if (this.form.floor !== null) {
          params.houseFloorImageId = this.form.floor;
        }

        if(this.marker !== null) {
          params.x = this.marker.x;
          params.y = this.marker.y;
        }


        try {
          
          await this.axios.post(this.$store.state.api_endpoint + '/signal/', params);


          this.form = {
            object: null,
            location: null,
            place: null,
            problem: null,
            comment: null,
            floor: null,
            images: [],
          };

          this.panzoom = null;
          this.marker = null;

          window.scrollTo(0, 0);

          setTimeout(() => {
            
            this.$refs.messageDialogue.show({ message: 'Обращение отправлено', okButton: 'Подтвердить' });

          }, 500);



        } catch (e) {
          this.$refs.messageDialogue.show({ message: 'Произошла ошибка отправки сигнала', okButton: 'Подтвердить' });
        }

        // Выключаем барашка
        btn.classList.remove('btn--load');


      },


    }
  }
</script>

<style scoped>
  .scheme {
    width: 100%;
    height: 250px;
    border: 1px dashed var(--cozh-grey);
    border-radius: 8px;
  }

  .scheme__container {
    display: flex;
  }
  .scheme__image {
    display: block;
    margin: 0 auto;
  }
  .scheme__marker {
    position: absolute;
    background-color: red;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    cursor: pointer;
    transform: translate(-50%, -50%);
  }
</style>